const countdown = {
	data() {
		return {
			countParams: {
				time: 60,
				txt: this.$t('sendAsd'),
				disabled: false
			},
			countdownTimer: null
		}
	},
	methods: {
		countdown(callback) {
			let _self = this

			if (!_self.countParams.disabled) {
				let originParams = Object.assign({}, _self.countParams)
				
				! function countdown() {
					if (_self.countParams.time <= 0) {
						_self.countParams = originParams
						typeof callback == 'function' && callback()
						return false
					} else {
						_self.countParams.disabled = true
						_self.countParams.txt = _self.countParams.time + 's'
						_self.countParams.time--
					}
					_self.countdownTimer = setTimeout(function() {
						countdown()
					}, 1000)
				}()
			}
		}
	}
}
export default countdown
